import { CATEGORIES } from '../data/categories';
import styles from './FilterBar.module.css';

export default function FilterBar({ friends, activeCategory, activePeople, onCategoryChange, onPersonChange }) {
  return (
    <div className={styles.wrapper}>
      <div className={styles.row}>
        <button
          className={`${styles.chip} ${!activeCategory ? styles.active : ''}`}
          onClick={() => onCategoryChange(null)}
        >
          All
        </button>
        {CATEGORIES.map(cat => (
          <button
            key={cat.key}
            className={`${styles.chip} ${activeCategory === cat.key ? styles.active : ''}`}
            style={activeCategory === cat.key ? { '--chip-color': `var(${cat.accentVar})` } : {}}
            onClick={() => onCategoryChange(activeCategory === cat.key ? null : cat.key)}
          >
            {cat.icon} {cat.label}
            {activeCategory === cat.key && <span className={styles.clear}>×</span>}
          </button>
        ))}
      </div>

      {friends.length > 0 && (
        <div className={styles.row}>
          {friends.map(friend => {
            const isActive = activePeople.has(friend.userId);
            return (
              <button
                key={friend.userId}
                className={`${styles.chip} ${styles.personChip} ${isActive ? styles.active : ''}`}
                onClick={() => onPersonChange(friend.userId)}
              >
                {friend.photoURL ? (
                  <img src={friend.photoURL} alt={friend.displayName} className={styles.personAvatar} />
                ) : (
                  <span className={styles.personAvatarFallback}>
                    {friend.displayName.charAt(0).toUpperCase()}
                  </span>
                )}
                {friend.displayName}
                {isActive && <span className={styles.clear}>×</span>}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
